module.exports = {
  "id": "f9a0d0e3-c3cf-49d9-a2c4-fb48bf21602c",
  "gtmIds": [
    "GTM-PQDH4HCM",
    "GTM-T2TNT6",
    "GTM-KKS578WK"
  ],
  "hasInAppVersion": false,
  "group": "moreys",
  "language": "en-US",
  "defaultDateFormat": "WEEKDAY_SHORT_MONTH_SHORT_DAY_INTL",
  "defaultNumberFormat": null,
  "languages": [
    "en-US"
  ],
  "website": "https://www.stubborn-bros.com",
  "imageDeliveryUrl": "public-assets.spotliodata.com"
}